import EpcCalculation = require("./EpcCalculation");

export interface IProductionEstimateResult {
    annualProduction: number;
    systemSize: number;
}

export class ProductionEstimateResult implements IProductionEstimateResult {
    annualProduction: number;
    systemSize: number;
}

export interface IProductionEstimateReconcileSummary {
    previousEpcCalculation: EpcCalculation.IEpcCalculationResult;
    associatedEpcCalculation: EpcCalculation.IEpcCalculationResult;
    productionEstimate: IProductionEstimateResult;
}

export class ProductionEstimateReconcileSummary implements IProductionEstimateReconcileSummary {
    previousEpcCalculation: EpcCalculation.IEpcCalculationResult;
    associatedEpcCalculation: EpcCalculation.IEpcCalculationResult;
    productionEstimate: IProductionEstimateResult;
}
